import { useCallback } from 'react';
import { useModal } from './useModalV2';

export function useCallbackWithConditionalConfirmation(
  requiresConfirmation: boolean,
  {
    title,
    description,
    onConfirmCallback,
  }: {
    title: string;
    description: string;
    onConfirmCallback: () => void;
  },
) {
  const { confirm } = useModal();
  const confirmBeforeCallback = useCallback(
    () =>
      confirm({
        title,
        description,
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',
        danger: true,
      }),
    [confirm, description, title],
  );
  const onCallbackWithConfirmation = useCallback(async () => {
    if (requiresConfirmation) {
      const confirmed = await confirmBeforeCallback();
      if (confirmed) {
        onConfirmCallback();
      }
    } else {
      onConfirmCallback();
    }
  }, [requiresConfirmation, confirmBeforeCallback, onConfirmCallback]);

  return onCallbackWithConfirmation;
}
